import { __decorate } from "tslib";
import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
let BayTableColumnMappingService = class BayTableColumnMappingService {
    bayTableColumnMap = new BehaviorSubject(null);
    bayTableColumnMapObservable = this.bayTableColumnMap.asObservable();
    bayTableItems = new BehaviorSubject(null);
    bayTableItemsObservable = this.bayTableItems.asObservable();
    createApplication = new BehaviorSubject(null);
    createApplicationObservable = this.createApplication.asObservable();
    constructor() {
    }
    setBayTableColumnMap(tableColumnMap) {
        this.bayTableColumnMap.next(tableColumnMap);
    }
    setBayTableItems(tableItems) {
        this.bayTableItems.next(tableItems);
    }
    createApplicationRequest(property) {
        this.createApplication.next(property);
    }
    static ctorParameters = () => [];
};
BayTableColumnMappingService = __decorate([
    Injectable({
        providedIn: "root"
    })
], BayTableColumnMappingService);
export { BayTableColumnMappingService };
